/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Native_Release_Strava_Connected_PlainInputs */

const en_us2_native_release_strava_connected_plain = /** @type {(inputs: Native_Release_Strava_Connected_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected`)
};

const pt_br2_native_release_strava_connected_plain = /** @type {(inputs: Native_Release_Strava_Connected_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectado`)
};

const pt_pt2_native_release_strava_connected_plain = /** @type {(inputs: Native_Release_Strava_Connected_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectado`)
};

/** @type {(inputs: Native_Release_Strava_Connected_PlainInputs) => LocalizedString} */
const es_419_native_release_strava_connected_plain = en_us2_native_release_strava_connected_plain;

/** @type {(inputs: Native_Release_Strava_Connected_PlainInputs) => LocalizedString} */
const fr_fr2_native_release_strava_connected_plain = en_us2_native_release_strava_connected_plain;

/** @type {(inputs: Native_Release_Strava_Connected_PlainInputs) => LocalizedString} */
const de_de2_native_release_strava_connected_plain = en_us2_native_release_strava_connected_plain;

/** @type {(inputs: Native_Release_Strava_Connected_PlainInputs) => LocalizedString} */
const it_it2_native_release_strava_connected_plain = en_us2_native_release_strava_connected_plain;

/**
* | output |
* | --- |
* | "Connected" |
*
* @param {Native_Release_Strava_Connected_PlainInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const native_release_strava_connected_plain = /** @type {((inputs?: Native_Release_Strava_Connected_PlainInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Native_Release_Strava_Connected_PlainInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_native_release_strava_connected_plain(inputs)
	if (locale === "es-419") return es_419_native_release_strava_connected_plain(inputs)
	if (locale === "pt-PT") return pt_pt2_native_release_strava_connected_plain(inputs)
	if (locale === "fr-FR") return fr_fr2_native_release_strava_connected_plain(inputs)
	if (locale === "de-DE") return de_de2_native_release_strava_connected_plain(inputs)
	if (locale === "it-IT") return it_it2_native_release_strava_connected_plain(inputs)
	return en_us2_native_release_strava_connected_plain(inputs)
});
export { native_release_strava_connected_plain as "native-release.strava_connected_plain" }